<template>
  <div class="tpl-card" :class="{ active: selected }" @click="$emit('select', template)">
    <div class="tpl-card__head">
      <div class="tpl-card__radio">
        <span class="dot" :class="{ on: selected }"></span>
      </div>
      <div class="tpl-card__name" :title="template.template_name">{{ template.template_name }}</div>
      <div class="tpl-card__actions">
        <el-tooltip content="编辑" placement="top">
          <el-icon class="action-icon" @click.stop="$emit('edit', template)"><Edit /></el-icon>
        </el-tooltip>
        <el-tooltip content="复制为新模板" placement="top">
          <el-icon class="action-icon" @click.stop="$emit('duplicate', template)"><DocumentCopy /></el-icon>
        </el-tooltip>
        <el-tooltip content="删除" placement="top">
          <el-icon class="action-icon action-icon--danger" @click.stop="$emit('delete', template)"><Delete /></el-icon>
        </el-tooltip>
      </div>
    </div>

    <div class="tpl-card__meta">
      <span>更新时间：{{ template.updated_time || '--' }}</span>
      <span>创建人：{{ template.create_by || '--' }}</span>
    </div>

    <!-- 备注标签，超出省略，hover 展示全部 -->
      <div class="tpl-card__memo">{{ template.memo || '暂无备注' }}</div>
    

    <!-- 迷你时段预览条：工作日 -->
    <div class="tpl-card__preview">
      <div v-for="seg in previewSegments" :key="seg.key" class="seg" :style="{ left: seg.left, width: seg.width, background: seg.color }"></div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { Edit, DocumentCopy, Delete } from '@element-plus/icons-vue'

const props = defineProps({
  template: { type: Object, required: true },
  selected: { type: Boolean, default: false },
})

const emit = defineEmits(['select', 'edit', 'duplicate', 'delete'])

// 把工作日策略时段换算成 0~100% 的定位条
const previewSegments = computed(() => {
  const list = props.template.strategys_work || []
  return list.map((s, i) => {
    const [sh, sm] = String(s.start_time || '00:00').split(':').map(Number)
    const [eh, em] = String(s.end_time || '00:00').split(':').map(Number)
    const start = (sh * 60 + sm) / 1440
    let end = (eh * 60 + em) / 1440
    if (end <= start) end = 1
    const power = Number(s.power)
    // 与详情图表(createOption)保持一致：充#24A517 / 放#596EFF / 无功率#BCC6DD
    let color = '#BCC6DD'
    if (power > 0) color = '#24A517'
    else if (power < 0) color = '#596EFF'
    return { key: `${i}-${s.start_time}`, left: `${start * 100}%`, width: `${Math.max(1, (end - start) * 100)}%`, color }
  })
})
</script>

<style scoped lang="scss">
.tpl-card {
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 14px;
  padding: 12px 14px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: rgba(58, 104, 255, 0.4);
    z-index: 10;
  }
  &.active {
    border-color: #3A68FF;
    background: #F3F6FF;
    box-shadow: 0 4px 14px rgba(58, 104, 255, 0.12);
    z-index: 5;
  }
}

.tpl-card__head {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tpl-card__radio {
  flex-shrink: 0;
  .dot {
    display: inline-block;
    width: 14px; height: 14px;
    border-radius: 50%;
    border: 2px solid #C4CCDC;
    box-sizing: border-box;
    transition: all 0.2s;
    &.on { border-color: #3A68FF; background: radial-gradient(circle, #3A68FF 40%, #fff 45%); }
  }
}

.tpl-card__name {
  font-size: 14px;
  font-weight: 600;
  color: #2e2e2e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
}

.tpl-card__actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
  align-items: center;
}

.action-icon {
  font-size: 16px;
  color: rgba(46, 46, 46, 0.4);
  cursor: pointer;
  padding: 2px;
  transition: all 0.2s;

  &:hover {
    color: #3A68FF;
    transform: scale(1.1);
  }

  &--danger:hover {
    color: #F56C6C;
  }
}

.tpl-card__meta {
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: rgba(46, 46, 46, 0.5);
}

.tpl-card__memo {
  margin-top: 6px;
  font-size: 12px;
  color: rgba(46, 46, 46, 0.6);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.tpl-card__preview {
  position: relative;
  height: 10px;
  margin-top: 10px;
  border-radius: 6px;
  background: #EEF1F8;
  overflow: hidden;

  .seg { position: absolute; top: 0; height: 100%; border-radius: 4px; }
}
</style>
